import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../store/Slices/AuthSlice';
import '../styles/Auth.css';
import { loginSchema } from '../utils/Schema';
import { emailIcon, passwordIcon } from '../utils/svgs';
import { errorNotify, successNotify } from '../utils/toast';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error } = useSelector((state) => state.auth);

    const [showPassword, setShowPassword] = useState(false);

    const handleLogin = async (values, { setSubmitting }) => {
        try {
            const resultAction = await dispatch(loginUser({
                email: values.email,
                password: values.password
            }));

            if (loginUser.fulfilled.match(resultAction)) {
                const userDetails = resultAction.payload.data.user_details;

                if (!userDetails?.password_changed) {
                    navigate('/change-default-password');
                    return;
                }

                if (userDetails.user_sidebar.length === 0 && userDetails.my_role.slug !== 'super-admin') {
                    errorNotify('No permissions assigned to the user');
                    return;
                }

                localStorage.setItem('fms-maintenance-details', JSON.stringify(userDetails));
                successNotify('Login successful');

                if (userDetails.user_sidebar && userDetails.user_sidebar.length > 0) {
                    const firstMenu = userDetails.user_sidebar[0];
                    const redirectPath = firstMenu.slug.startsWith('/') ? firstMenu.slug : `/${firstMenu.slug}`;
                    navigate(redirectPath);
                } else {
                    navigate('/dashboard');
                }
            }
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className='main_auth_screen'>
            <Container fluid>
                <Row>
                    <Col md={7} className='auth_left'>
                        <div>
                            <h2>Maintenance</h2>
                            <h6>Maintenance Module Login</h6>
                        </div>
                    </Col>
                    <Col md={5} className='auth_col'>
                        <div className='auth_form'>
                            <div>
                                <h1>Hello Again!</h1>
                                <p>Welcome back</p>

                                <div className='auth_inputs'>
                                    <Formik
                                        initialValues={{
                                            email: '',
                                            password: ''
                                        }}
                                        validationSchema={loginSchema}
                                        onSubmit={handleLogin}
                                    >
                                        {({ isSubmitting }) => (
                                            <Form>
                                                <div className='mb-3'>
                                                    <div className="form-group">
                                                        {emailIcon}
                                                        <Field
                                                            type='email'
                                                            name='email'
                                                            placeholder='Email Address'
                                                            className="form-control"
                                                        />
                                                    </div>
                                                    <ErrorMessage name="email" component="div" className="error-message" />
                                                </div>

                                                <div className='mb-3'>
                                                    <div className="form-group password-field">
                                                        {passwordIcon}
                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                            <Field
                                                                type={showPassword ? 'text' : 'password'}
                                                                name='password'
                                                                placeholder='Password'
                                                                className="form-control"
                                                            />
                                                            <span
                                                                className="password-toggle-icon"
                                                                onClick={() => setShowPassword(!showPassword)}
                                                            >
                                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <ErrorMessage name="password" component="div" className="error-message" />
                                                </div>

                                                {error && (
                                                    <div className="error-message" style={{ color: 'red', marginBottom: '10px', fontSize: "13px" }}>
                                                        {error}
                                                    </div>
                                                )}

                                                <div className='forgot_password' onClick={() => navigate('/forgot-password')}>Forgot password</div>

                                                <button
                                                    type='submit'
                                                    disabled={isSubmitting || loading}
                                                >
                                                    {loading || isSubmitting ? 'Logging in...' : 'Login'}
                                                </button>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Login